import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Calendar, SocialNetworkIcon, ButtonBar } from 'components';
import { FlyoutSection } from 'containers';
import { LLCheckbox } from 'components/FormElements';
import { setTeamStatusSelection } from 'redux/modules/teamManagement';
import styles from './TeamFilterPanel.scss';
var TeamFilterPanel = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    selectedStatus: state.teamManagement.teamListViewStatus
  };
}, {
  setTeamStatusSelection: setTeamStatusSelection
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TeamFilterPanel, _Component);

  var _super = _createSuper(TeamFilterPanel);

  function TeamFilterPanel() {
    var _this;

    _classCallCheck(this, TeamFilterPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleStatusSelection", function (item) {
      _this.props.setTeamStatusSelection(item.status);
    });

    return _this;
  }

  _createClass(TeamFilterPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      console.log(this.props.selectedStatus);
      var buttonBarItems = [{
        title: 'ACTIVE',
        selected: this.props.selectedStatus !== 'INACTIVE',
        status: 'ACTIVE'
      }, {
        title: 'INACTIVE',
        selected: this.props.selectedStatus === 'INACTIVE',
        status: 'INACTIVE'
      }];
      var selectedDate = this.props.selectedDate ? moment(this.props.selectedDate) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.filters
      }, /*#__PURE__*/React.createElement(FlyoutSection, {
        title: "VIEW"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 10
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", null, "Team Members:")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        items: buttonBarItems,
        onChange: this.handleStatusSelection
      })))));
    }
  }]);

  return TeamFilterPanel;
}(Component), _defineProperty(_class2, "propTypes", {}), _defineProperty(_class2, "defaultProps", {
  filters: []
}), _temp)) || _class);
export { TeamFilterPanel as default };